import React from 'react';

function Portugal(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124017)">
        <mask
          id="mask0_800_124017"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124017)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 0H36V24H9V0Z"
            fill="#EF0000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H13.5V24H0V0Z"
            fill="#2F8D00"
          />
          <mask
            id="mask1_800_124017"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="4"
            y="4"
            width="19"
            height="16"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.3929 19.8072C8.59988 19.8072 4.71436 16.3118 4.71436 12C4.71436 7.6882 8.59988 4.19278 13.3929 4.19278C18.186 4.19278 22.0715 7.6882 22.0715 12C22.0715 16.3118 18.186 19.8072 13.3929 19.8072Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124017)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.8572 4H13.9822V6.6988H12.8572V4Z"
              fill="#FFE017"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.8572 17.494H13.9822V20H12.8572V17.494Z"
              fill="#FFE017"
            />
            <path
              d="M4.85384 12.4038L4.53931 11.6865C8.01014 10.4548 10.6298 9.6605 12.4073 9.30252C15.0151 8.77732 17.8806 8.38873 21.0038 8.13647L21.0805 8.90447C17.9931 9.15383 15.1644 9.53743 12.5945 10.055C10.8699 10.4023 8.28669 11.1856 4.85384 12.4038Z"
              fill="#FFE017"
            />
            <path
              d="M21.5336 7.6639L21.2784 8.40001C18.6552 7.66389 16.5184 7.34748 14.8758 7.44548L14.8191 6.67609C16.5826 6.57086 18.8181 6.90189 21.5336 7.6639Z"
              fill="#FFE017"
            />
            <path
              d="M22.4411 11.7798L21.9562 12.4156C20.6189 11.5904 18.9714 11.1758 17.0024 11.1758V10.4048C19.137 10.4048 20.9536 10.8618 22.4411 11.7798Z"
              fill="#FFE017"
            />
            <path
              d="M21.7148 12.0106L21.9364 12.7554C19.0534 13.4496 16.3468 13.8434 13.8161 13.9361C11.2681 14.0295 8.29821 13.6343 4.90405 12.7534L5.14163 12.0126C8.4533 12.872 11.334 13.2554 13.7812 13.1657C16.2459 13.0754 18.8905 12.6906 21.7148 12.0106Z"
              fill="#FFE017"
            />
            <path
              d="M21.3884 15.6359L20.0335 16.8706C17.4587 14.584 15.1919 12.949 13.2471 11.9667C11.269 10.9675 8.68934 9.95293 5.51221 8.92703L6.16375 7.2941C9.43458 8.35025 12.1091 9.40215 14.1913 10.4539C16.3067 11.5224 18.7011 13.2494 21.3884 15.6359Z"
              fill="#FFE017"
            />
            <path
              d="M6.14077 16.3353L5.62793 15.7175C5.69955 15.6694 5.82733 15.5891 6.0034 15.4875C6.29409 15.3196 6.6169 15.152 6.96421 14.9954C7.92081 14.5641 8.88036 14.2947 9.79557 14.27C9.84033 14.2688 9.8849 14.2682 9.92928 14.2682V15.0393C9.89353 15.0393 9.85754 15.0398 9.82131 15.0407C9.05005 15.0616 8.20307 15.2993 7.3483 15.6847C7.0297 15.8284 6.73284 15.9825 6.46643 16.1364C6.37369 16.1899 6.29164 16.2394 6.22134 16.2836C6.18034 16.3093 6.15314 16.327 6.14077 16.3353Z"
              fill="#FFE017"
            />
            <path
              d="M6.53882 16.6026L6.75467 15.8563C9.61231 16.5253 11.8154 16.8586 13.3529 16.8586C14.8847 16.8586 17.1646 16.4654 20.1778 15.6763L20.4174 16.4166C17.3329 17.2245 14.983 17.6297 13.3529 17.6297C11.7285 17.6297 9.46084 17.2866 6.53882 16.6026Z"
              fill="#FFE017"
            />
            <path
              d="M5.42529 9.69443L6.78325 8.46249L8.77149 10.2361L7.41353 11.4681L5.42529 9.69443Z"
              fill="#FFE017"
            />
            <path
              d="M16.6904 15.8478L17.7005 14.3698L20.8546 16.1143L19.8445 17.5922L16.6904 15.8478Z"
              fill="#FFE017"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.71436 12C4.71436 16.3118 8.59988 19.8072 13.3929 19.8072C18.186 19.8072 22.0715 16.3118 22.0715 12C22.0715 7.6882 18.186 4.19278 13.3929 4.19278C8.59988 4.19278 4.71436 7.6882 4.71436 12ZM21 12.0964C21 15.8226 17.6422 18.8434 13.5 18.8434C9.35789 18.8434 6.00003 15.8226 6.00003 12.0964C6.00003 8.37012 9.35789 5.3494 13.5 5.3494C17.6422 5.3494 21 8.37012 21 12.0964Z"
            fill="#F9E813"
          />
          <path
            d="M8.61377 7.18527V13.446C9.07742 15.9241 10.6394 17.1631 13.2998 17.1631C15.9602 17.1631 17.5222 15.9241 17.9859 13.446V7.18527H8.61377Z"
            fill="white"
          />
          <path
            d="M7.97095 6.60696H18.6288V13.4943L18.6199 13.542C18.105 16.2936 16.2799 17.7414 13.2999 17.7414C10.3199 17.7414 8.49471 16.2936 7.97986 13.542L7.97095 13.4943V6.60696Z"
            fill="#C51918"
          />
          <path
            d="M10.4089 8.71069H16.1911V13.1516C16.1911 13.1516 15.762 15.4449 13.3 15.4449C10.838 15.4449 10.4089 13.1516 10.4089 13.1516V8.71069Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 7.08435H9.81325V7.56628H9V7.08435Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 7.27711H10.0715V7.51808H8.57153V7.27711Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 7.46989H9.38479V7.71086H8.57153V7.46989Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.42871 7.46988H10.242V7.71084H9.42871V7.46988Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 8.0482H9.1137V8.77109H8.57153V8.0482Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.64307 8.04822H10.1852V8.77111H9.64307V8.04822Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.21436 8.04822H9.48544V8.77111H9.21436V8.04822Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 7.85544H10.0715V8.0964H8.57153V7.85544Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 8.43375H10.0715V8.67471H8.57153V8.43375Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.78564 7.66266H9.05673V7.90362H8.78564V7.66266Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.64307 7.66266H9.91415V7.90362H9.64307V7.66266Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.21436 7.46988H9.48544V7.95181H9.21436V7.46988Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0713 7.08435H13.8845V7.56628H13.0713V7.08435Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6428 7.27711H14.1428V7.51808H12.6428V7.27711Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6428 7.46989H13.4561V7.71086H12.6428V7.46989Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 7.46988H14.3133V7.71084H13.5V7.46988Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6428 8.0482H13.185V8.77109H12.6428V8.0482Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7144 8.04822H14.2565V8.77111H13.7144V8.04822Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2856 8.04822H13.5567V8.77111H13.2856V8.04822Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6428 7.85544H14.1428V8.0964H12.6428V7.85544Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6428 8.43375H14.1428V8.67471H12.6428V8.43375Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8569 7.66266H13.128V7.90362H12.8569V7.66266Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7144 7.66266H13.9854V7.90362H13.7144V7.66266Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2856 7.46988H13.5567V7.95181H13.2856V7.46988Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9285 7.08435H17.7417V7.56628H16.9285V7.08435Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 7.27711H18V7.51808H16.5V7.27711Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 7.46989H17.3133V7.71086H16.5V7.46989Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3572 7.46988H18.1704V7.71084H17.3572V7.46988Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 8.0482H17.0422V8.77109H16.5V8.0482Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5713 8.04822H18.1135V8.77111H17.5713V8.04822Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1428 8.04822H17.4139V8.77111H17.1428V8.04822Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 7.85544H18V8.0964H16.5V7.85544Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 8.43375H18V8.67471H16.5V8.43375Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7141 7.66266H16.9852V7.90362H16.7141V7.66266Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5713 7.66266H17.8424V7.90362H17.5713V7.66266Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1428 7.46988H17.4139V7.95181H17.1428V7.46988Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9285 10.5542H17.7417V11.0362H16.9285V10.5542Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 10.747H18V10.988H16.5V10.747Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 10.9398H17.3133V11.1807H16.5V10.9398Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3572 10.9398H18.1704V11.1807H17.3572V10.9398Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 11.5181H17.0422V12.241H16.5V11.5181Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5713 11.5181H18.1135V12.241H17.5713V11.5181Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1428 11.5181H17.4139V12.241H17.1428V11.5181Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 11.3253H18V11.5663H16.5V11.3253Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 11.9036H18V12.1446H16.5V11.9036Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7141 11.1325H16.9852V11.3735H16.7141V11.1325Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5713 11.1325H17.8424V11.3735H17.5713V11.1325Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1428 10.9398H17.4139V11.4217H17.1428V10.9398Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 10.5542H9.81325V11.0362H9V10.5542Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 10.747H10.0715V10.988H8.57153V10.747Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 10.9398H9.38479V11.1807H8.57153V10.9398Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.42871 10.9398H10.242V11.1807H9.42871V10.9398Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 11.5181H9.1137V12.241H8.57153V11.5181Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.64307 11.5181H10.1852V12.241H9.64307V11.5181Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.21436 11.5181H9.48544V12.241H9.21436V11.5181Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 11.3253H10.0715V11.5663H8.57153V11.3253Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57153 11.9036H10.0715V12.1446H8.57153V11.9036Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.78564 11.1325H9.05673V11.3735H8.78564V11.1325Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.64307 11.1325H9.91415V11.3735H9.64307V11.1325Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.21436 10.9398H9.48544V11.4217H9.21436V10.9398Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.52173 14.904L10.0445 14.3502L10.4598 14.66L9.93705 15.2137L9.52173 14.904Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.4126 15.3197L10.3768 14.2983L10.5844 14.4532L9.62026 15.4746L9.4126 15.3197Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.57861 15.4436L10.1014 14.8899L10.309 15.0448L9.78628 15.5985L9.57861 15.4436Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1294 14.86L10.6521 14.3062L10.8598 14.4611L10.3371 15.0148L10.1294 14.86Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0771 15.8154L10.4256 15.4462L11.0486 15.9109L10.7001 16.28L10.0771 15.8154Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7659 15.0858L11.1144 14.7166L11.7374 15.1813L11.3889 15.5505L10.7659 15.0858Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4902 15.3776L10.6645 15.193L11.2875 15.6577L11.1132 15.8423L10.4902 15.3776Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.91089 15.6914L10.8751 14.67L11.0827 14.8249L10.1186 15.8463L9.91089 15.6914Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4092 16.0632L11.3734 15.0418L11.581 15.1967L10.6168 16.2181L10.4092 16.0632Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.88257 15.4216L10.0568 15.237L10.2645 15.3919L10.0902 15.5765L9.88257 15.4216Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4333 14.838L10.6076 14.6534L10.8153 14.8083L10.641 14.9929L10.4333 14.838Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.9917 15.0059L10.1659 14.8213L10.5813 15.1311L10.407 15.3157L9.9917 15.0059Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8508 14.4662L17.3736 15.02L16.9583 15.3298L16.4355 14.776L16.8508 14.4662Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.4092 14.2983L17.3734 15.3197L17.1657 15.4746L16.2015 14.4532L16.4092 14.2983Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2432 14.4222L16.7659 14.976L16.5583 15.1309L16.0355 14.5771L16.2432 14.4222Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7942 15.0059L17.3169 15.5597L17.1093 15.7145L16.5865 15.1608L16.7942 15.0059Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7446 14.794L16.0931 15.1632L15.4701 15.6278L15.1216 15.2586L15.7446 14.794Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.4333 15.5235L16.7818 15.8927L16.1589 16.3574L15.8104 15.9882L16.4333 15.5235Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.158 15.2317L16.3322 15.4163L15.7092 15.8809L15.535 15.6964L16.158 15.2317Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9109 14.67L16.8751 15.6914L16.6674 15.8463L15.7032 14.8249L15.9109 14.67Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4126 15.0418L16.3768 16.0632L16.1691 16.2181L15.2049 15.1967L15.4126 15.0418Z"
            fill="#060101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2148 14.692L16.3891 14.8766L16.1814 15.0315L16.0072 14.8469L16.2148 14.692Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7659 15.2757L16.9401 15.4603L16.7325 15.6152L16.5582 15.4306L16.7659 15.2757Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6565 14.86L16.8307 15.0445L16.4154 15.3543L16.2412 15.1697L16.6565 14.86Z"
            fill="#F9E813"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1282 9.20483H12.6428V10.1663C12.6428 10.1663 12.753 10.6628 13.3855 10.6628C14.018 10.6628 14.1282 10.1663 14.1282 10.1663V9.20483ZM13.2856 9.59038C13.2856 9.69685 13.1897 9.78316 13.0713 9.78316C12.953 9.78316 12.857 9.69685 12.857 9.59038C12.857 9.48392 12.953 9.39761 13.0713 9.39761C13.1897 9.39761 13.2856 9.48392 13.2856 9.59038ZM13.0713 10.5542C13.1897 10.5542 13.2856 10.4679 13.2856 10.3615C13.2856 10.255 13.1897 10.1687 13.0713 10.1687C12.953 10.1687 12.857 10.255 12.857 10.3615C12.857 10.4679 12.953 10.5542 13.0713 10.5542ZM13.9286 10.3615C13.9286 10.4679 13.8326 10.5542 13.7143 10.5542C13.5959 10.5542 13.5 10.4679 13.5 10.3615C13.5 10.255 13.5959 10.1687 13.7143 10.1687C13.8326 10.1687 13.9286 10.255 13.9286 10.3615ZM13.3928 10.1687C13.5111 10.1687 13.6071 10.0824 13.6071 9.97591C13.6071 9.86945 13.5111 9.78314 13.3928 9.78314C13.2745 9.78314 13.1785 9.86945 13.1785 9.97591C13.1785 10.0824 13.2745 10.1687 13.3928 10.1687ZM13.9286 9.59038C13.9286 9.69685 13.8326 9.78316 13.7143 9.78316C13.5959 9.78316 13.5 9.69685 13.5 9.59038C13.5 9.48392 13.5959 9.39761 13.7143 9.39761C13.8326 9.39761 13.9286 9.48392 13.9286 9.59038Z"
            fill="#013399"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1282 11.3253H12.6428V12.2868C12.6428 12.2868 12.753 12.7833 13.3855 12.7833C14.018 12.7833 14.1282 12.2868 14.1282 12.2868V11.3253ZM13.2856 11.7109C13.2856 11.8173 13.1897 11.9036 13.0713 11.9036C12.953 11.9036 12.857 11.8173 12.857 11.7109C12.857 11.6044 12.953 11.5181 13.0713 11.5181C13.1897 11.5181 13.2856 11.6044 13.2856 11.7109ZM13.0713 12.6747C13.1897 12.6747 13.2856 12.5884 13.2856 12.482C13.2856 12.3755 13.1897 12.2892 13.0713 12.2892C12.953 12.2892 12.857 12.3755 12.857 12.482C12.857 12.5884 12.953 12.6747 13.0713 12.6747ZM13.9286 12.482C13.9286 12.5884 13.8326 12.6747 13.7143 12.6747C13.5959 12.6747 13.5 12.5884 13.5 12.482C13.5 12.3755 13.5959 12.2892 13.7143 12.2892C13.8326 12.2892 13.9286 12.3755 13.9286 12.482ZM13.3928 12.2892C13.5111 12.2892 13.6071 12.2029 13.6071 12.0964C13.6071 11.9899 13.5111 11.9036 13.3928 11.9036C13.2745 11.9036 13.1785 11.9899 13.1785 12.0964C13.1785 12.2029 13.2745 12.2892 13.3928 12.2892ZM13.9286 11.7109C13.9286 11.8173 13.8326 11.9036 13.7143 11.9036C13.5959 11.9036 13.5 11.8173 13.5 11.7109C13.5 11.6044 13.5959 11.5181 13.7143 11.5181C13.8326 11.5181 13.9286 11.6044 13.9286 11.7109Z"
            fill="#013399"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0569 11.3253H14.5715V12.2868C14.5715 12.2868 14.6818 12.7833 15.3142 12.7833C15.9467 12.7833 16.0569 12.2868 16.0569 12.2868V11.3253ZM15.2144 11.7109C15.2144 11.8173 15.1184 11.9036 15.0001 11.9036C14.8817 11.9036 14.7858 11.8173 14.7858 11.7109C14.7858 11.6044 14.8817 11.5181 15.0001 11.5181C15.1184 11.5181 15.2144 11.6044 15.2144 11.7109ZM15.0001 12.6747C15.1184 12.6747 15.2144 12.5884 15.2144 12.482C15.2144 12.3755 15.1184 12.2892 15.0001 12.2892C14.8817 12.2892 14.7858 12.3755 14.7858 12.482C14.7858 12.5884 14.8817 12.6747 15.0001 12.6747ZM15.8573 12.482C15.8573 12.5884 15.7614 12.6747 15.643 12.6747C15.5247 12.6747 15.4288 12.5884 15.4288 12.482C15.4288 12.3755 15.5247 12.2892 15.643 12.2892C15.7614 12.2892 15.8573 12.3755 15.8573 12.482ZM15.3216 12.2892C15.4399 12.2892 15.5358 12.2029 15.5358 12.0964C15.5358 11.9899 15.4399 11.9036 15.3216 11.9036C15.2032 11.9036 15.1073 11.9899 15.1073 12.0964C15.1073 12.2029 15.2032 12.2892 15.3216 12.2892ZM15.8573 11.7109C15.8573 11.8173 15.7614 11.9036 15.643 11.9036C15.5247 11.9036 15.4288 11.8173 15.4288 11.7109C15.4288 11.6044 15.5247 11.5181 15.643 11.5181C15.7614 11.5181 15.8573 11.6044 15.8573 11.7109Z"
            fill="#013399"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1997 11.3253H10.7144V12.2868C10.7144 12.2868 10.8246 12.7833 11.457 12.7833C12.0895 12.7833 12.1997 12.2868 12.1997 12.2868V11.3253ZM11.3572 11.7109C11.3572 11.8173 11.2613 11.9036 11.1429 11.9036C11.0246 11.9036 10.9286 11.8173 10.9286 11.7109C10.9286 11.6044 11.0246 11.5181 11.1429 11.5181C11.2613 11.5181 11.3572 11.6044 11.3572 11.7109ZM11.1429 12.6747C11.2613 12.6747 11.3572 12.5884 11.3572 12.482C11.3572 12.3755 11.2613 12.2892 11.1429 12.2892C11.0246 12.2892 10.9286 12.3755 10.9286 12.482C10.9286 12.5884 11.0246 12.6747 11.1429 12.6747ZM12.0002 12.482C12.0002 12.5884 11.9042 12.6747 11.7859 12.6747C11.6675 12.6747 11.5716 12.5884 11.5716 12.482C11.5716 12.3755 11.6675 12.2892 11.7859 12.2892C11.9042 12.2892 12.0002 12.3755 12.0002 12.482ZM11.4644 12.2892C11.5828 12.2892 11.6787 12.2029 11.6787 12.0964C11.6787 11.9899 11.5828 11.9036 11.4644 11.9036C11.3461 11.9036 11.2501 11.9899 11.2501 12.0964C11.2501 12.2029 11.3461 12.2892 11.4644 12.2892ZM12.0002 11.7109C12.0002 11.8173 11.9042 11.9036 11.7859 11.9036C11.6675 11.9036 11.5716 11.8173 11.5716 11.7109C11.5716 11.6044 11.6675 11.5181 11.7859 11.5181C11.9042 11.5181 12.0002 11.6044 12.0002 11.7109Z"
            fill="#013399"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1282 13.4458H12.6428V14.4073C12.6428 14.4073 12.753 14.9038 13.3855 14.9038C14.018 14.9038 14.1282 14.4073 14.1282 14.4073V13.4458ZM13.2856 13.8314C13.2856 13.9378 13.1897 14.0241 13.0713 14.0241C12.953 14.0241 12.857 13.9378 12.857 13.8314C12.857 13.7249 12.953 13.6386 13.0713 13.6386C13.1897 13.6386 13.2856 13.7249 13.2856 13.8314ZM13.0713 14.7952C13.1897 14.7952 13.2856 14.7089 13.2856 14.6024C13.2856 14.496 13.1897 14.4097 13.0713 14.4097C12.953 14.4097 12.857 14.496 12.857 14.6024C12.857 14.7089 12.953 14.7952 13.0713 14.7952ZM13.9286 14.6024C13.9286 14.7089 13.8326 14.7952 13.7143 14.7952C13.5959 14.7952 13.5 14.7089 13.5 14.6024C13.5 14.496 13.5959 14.4097 13.7143 14.4097C13.8326 14.4097 13.9286 14.496 13.9286 14.6024ZM13.3928 14.4097C13.5111 14.4097 13.6071 14.3233 13.6071 14.2169C13.6071 14.1104 13.5111 14.0241 13.3928 14.0241C13.2745 14.0241 13.1785 14.1104 13.1785 14.2169C13.1785 14.3233 13.2745 14.4097 13.3928 14.4097ZM13.9286 13.8314C13.9286 13.9378 13.8326 14.0241 13.7143 14.0241C13.5959 14.0241 13.5 13.9378 13.5 13.8314C13.5 13.7249 13.5959 13.6386 13.7143 13.6386C13.8326 13.6386 13.9286 13.7249 13.9286 13.8314Z"
            fill="#013399"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124017">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Portugal;
